import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "d-none d-sm-block me-2" }
const _hoisted_5 = { class: "neon-avatar-border" }
const _hoisted_6 = {
  class: "flex-grow-1",
  style: {"min-width":"0"}
}
const _hoisted_7 = { class: "d-flex flex-nowrap" }
const _hoisted_8 = { class: "flex-shrink-0 me-auto" }
const _hoisted_9 = { class: "media-heading" }
const _hoisted_10 = { class: "list-inline mb-0 list-inline-bullet-sm" }
const _hoisted_11 = { class: "list-inline-item text-muted" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "list-inline-item small text-muted" }
const _hoisted_14 = {
  key: 0,
  class: "list-inline-item small text-muted"
}
const _hoisted_15 = { class: "microblog-tags" }
const _hoisted_16 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_17 = {
  class: "btn btn-xs border-0 text-muted",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-label": "Dropdown"
}
const _hoisted_18 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_19 = {
  key: 3,
  class: "dropdown-divider"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["href", "title"]
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "text-truncate mb-0" }
const _hoisted_24 = { class: "text-truncate" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = {
  key: 1,
  class: "row mb-2"
}
const _hoisted_27 = ["onClick", "href"]
const _hoisted_28 = ["alt", "src"]
const _hoisted_29 = { class: "microblog-actions" }
const _hoisted_30 = ["aria-label"]
const _hoisted_31 = ["data-metadata", "data-url"]
const _hoisted_32 = {
  ref: "comments",
  class: "microblog-comments"
}
const _hoisted_33 = {
  key: 0,
  class: "show-all-comments"
}
const _hoisted_34 = {
  key: 1,
  method: "POST"
}
const _hoisted_35 = { class: "media" }
const _hoisted_36 = { class: "neon-avatar-border i-35" }
const _hoisted_37 = { class: "media-body position-relative ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_avatar = _resolveComponent("vue-avatar")!
  const _component_vue_username = _resolveComponent("vue-username")!
  const _component_vue_timeago = _resolveComponent("vue-timeago")!
  const _component_vue_tags = _resolveComponent("vue-tags")!
  const _component_vue_icon = _resolveComponent("vue-icon")!
  const _component_vue_flag = _resolveComponent("vue-flag")!
  const _component_vue_see_more = _resolveComponent("vue-see-more")!
  const _component_vue_form = _resolveComponent("vue-form")!
  const _component_vue_comment = _resolveComponent("vue-comment")!
  const _component_vue_comment_form = _resolveComponent("vue-comment-form")!
  const _component_vue_gallery = _resolveComponent("vue-gallery")!
  const _directive_profile = _resolveDirective("profile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" we use below ID in mounted() method "),
    _createElementVNode("div", {
      id: `entry-${_ctx.microblog.id}`,
      class: "microblog neon-tile mb-3 p-3",
      style: {"border-radius":"8px"}
    }, [
      _createElementVNode("div", null, [
        (_ctx.microblog.deleted_at)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Ten wpis został usunięty. Możesz go przywrócić jeżeli chcesz. "))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives((_openBlock(), _createElementBlock("a", null, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_vue_avatar, _mergeProps(_ctx.microblog.user, {
                  "is-online": _ctx.microblog.user.is_online,
                  class: "i-45"
                }), null, 16 /* FULL_PROPS */, ["is-online"])
              ])
            ])), [
              [_directive_profile, _ctx.microblog.user.id]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h5", _hoisted_9, [
                  _createVNode(_component_vue_username, {
                    user: _ctx.microblog.user
                  }, null, 8 /* PROPS */, ["user"])
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, [
                    _createElementVNode("a", {
                      href: _ctx.microblog.url,
                      class: "small"
                    }, [
                      _createVNode(_component_vue_timeago, {
                        datetime: _ctx.microblog.created_at
                      }, null, 8 /* PROPS */, ["datetime"])
                    ], 8 /* PROPS */, _hoisted_12)
                  ]),
                  _createElementVNode("li", _hoisted_13, _toDisplayString(_ctx.microblog.views) + " " + _toDisplayString(_ctx.declination(_ctx.microblog.views, ['wyświetlenie', 'wyświetlenia', 'wyświetleń'])), 1 /* TEXT */),
                  (_ctx.microblog.is_sponsored)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, " Sponsorowane "))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_vue_tags, {
                  tags: _ctx.microblog.tags,
                  class: "tag-clouds-md"
                }, null, 8 /* PROPS */, ["tags"])
              ]),
              (_ctx.isAuthorized)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("button", _hoisted_17, [
                      _createVNode(_component_vue_icon, { name: "microblogMenuDropdown" })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.microblog.permissions.update)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!_ctx.microblog.deleted_at)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("a", {
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit(_ctx.microblog))),
                                    class: "dropdown-item",
                                    href: "javascript:"
                                  }, [
                                    _createVNode(_component_vue_icon, { name: "microblogEdit" }),
                                    _cache[14] || (_cache[14] = _createTextVNode(" Edytuj "))
                                  ]),
                                  _createElementVNode("a", {
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.deleteItem && $options.deleteItem(...args))),
                                    class: "dropdown-item",
                                    href: "javascript:"
                                  }, [
                                    _createVNode(_component_vue_icon, { name: "microblogDelete" }),
                                    _cache[15] || (_cache[15] = _createTextVNode(" Usuń "))
                                  ])
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.restoreItem && $options.restoreItem(...args))),
                                  class: "dropdown-item",
                                  href: "javascript:"
                                }, [
                                  _createVNode(_component_vue_icon, { name: "microblogRestore" }),
                                  _cache[16] || (_cache[16] = _createTextVNode(" Przywróć "))
                                ])),
                            (_ctx.microblog.permissions.moderate && !_ctx.microblog.deleted_at)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSponsored(_ctx.microblog))),
                                  class: "dropdown-item",
                                  href: "javascript:"
                                }, [
                                  _createVNode(_component_vue_icon, { name: "microblogSponsored" }),
                                  _cache[17] || (_cache[17] = _createTextVNode(" Sponsorowany "))
                                ]))
                              : _createCommentVNode("v-if", true),
                            (_ctx.microblog.user.id !== _ctx.user.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.microblog.user.id !== _ctx.user.id)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.block(_ctx.microblog.user))),
                            href: "javascript:",
                            class: "dropdown-item"
                          }, [
                            _createVNode(_component_vue_icon, { name: "microblogBlockAuthor" }),
                            _cache[18] || (_cache[18] = _createTextVNode(" Zablokuj użytkownika "))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_vue_see_more, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.flags, (flag) => {
                    return (_openBlock(), _createBlock(_component_vue_flag, {
                      key: flag.id,
                      flag: flag
                    }, null, 8 /* PROPS */, ["flag"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("div", {
                    ref: "microblog-text",
                    innerHTML: _ctx.microblog.html,
                    class: "microblog-text neon-contains-a-color-link"
                  }, null, 8 /* PROPS */, _hoisted_20),
                  ($options.opg)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $options.opg.metadata.url,
                        title: $options.opg.metadata.title,
                        class: "card microblog-opg",
                        target: "_blank"
                      }, [
                        _createElementVNode("div", {
                          class: "microblog-opg-image",
                          style: _normalizeStyle(`background-image: url(${$options.opg.url})`)
                        }, null, 4 /* STYLE */),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("h5", _hoisted_23, _toDisplayString($options.opg.metadata.title), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_24, _toDisplayString($options.opg.metadata.description), 1 /* TEXT */),
                          _createElementVNode("small", _hoisted_25, _toDisplayString($options.opg.metadata.url), 1 /* TEXT */)
                        ])
                      ], 8 /* PROPS */, _hoisted_21))
                    : _createCommentVNode("v-if", true),
                  ($options.images.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.images, (image, imageIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: imageIndex,
                            class: "col-6 col-md-3"
                          }, [
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => ($data.index = imageIndex), ["prevent"]),
                              href: image.url
                            }, [
                              _createElementVNode("img", {
                                alt: `Załącznik ${imageIndex}`,
                                class: "img-thumbnail",
                                src: image.thumbnail
                              }, null, 8 /* PROPS */, _hoisted_28)
                            ], 8 /* PROPS */, _hoisted_27)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ], 512 /* NEED_PATCH */), [
              [_vShow, !_ctx.microblog.is_editing]
            ]),
            (_ctx.microblog.is_editing)
              ? (_openBlock(), _createBlock(_component_vue_form, {
                  key: 0,
                  ref: "form",
                  microblog: _ctx.microblog,
                  class: "mt-2 mb-2",
                  onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.edit(_ctx.microblog))),
                  onSave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.edit(_ctx.microblog)))
                }, null, 8 /* PROPS */, ["microblog"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkAuth(_ctx.vote, _ctx.microblog))),
                onMouseenterOnce: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadVoters(_ctx.microblog))),
                class: "microblog-action",
                "aria-label": $options.voters,
                "data-balloon-pos": "up",
                "data-balloon-break": ""
              }, [
                (_ctx.microblog.is_voted)
                  ? (_openBlock(), _createBlock(_component_vue_icon, {
                      key: 0,
                      name: "microblogVoted",
                      class: "neon-primary-color"
                    }))
                  : (_openBlock(), _createBlock(_component_vue_icon, {
                      key: 1,
                      name: "microblogVote"
                    })),
                _createTextVNode(" " + _toDisplayString(' ') + " " + _toDisplayString(_ctx.microblog.votes) + " " + _toDisplayString(_ctx.declination(_ctx.microblog.votes, ['głos', 'głosy', 'głosów'])), 1 /* TEXT */)
              ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_30),
              _createElementVNode("span", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkAuth(_ctx.subscribe, _ctx.microblog))),
                class: "microblog-action",
                title: "Wł/Wył obserwowanie tego wpisu"
              }, [
                (_ctx.microblog.is_subscribed)
                  ? (_openBlock(), _createBlock(_component_vue_icon, {
                      key: 0,
                      name: "microblogSubscribed",
                      class: "neon-subscribe neon-subscribe--active"
                    }))
                  : (_openBlock(), _createBlock(_component_vue_icon, {
                      key: 1,
                      name: "microblogSubscribe",
                      class: "neon-subscribe"
                    })),
                _cache[19] || (_cache[19] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "d-none d-sm-inline" }, "Obserwuj", -1 /* HOISTED */))
              ]),
              _createElementVNode("span", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.checkAuth($options.reply, _ctx.microblog.user))),
                class: "microblog-action",
                title: "Odpowiedz na ten wpis"
              }, [
                _createVNode(_component_vue_icon, { name: "microblogAddComment" }),
                _cache[21] || (_cache[21] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "d-none d-sm-inline" }, "Komentuj", -1 /* HOISTED */))
              ]),
              _createElementVNode("span", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($options.copy && $options.copy(...args))),
                class: "microblog-action",
                title: "Kopiuj link do schowka"
              }, [
                _createVNode(_component_vue_icon, { name: "microblogShare" }),
                _cache[23] || (_cache[23] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "d-none d-sm-inline" }, "Udostępnij", -1 /* HOISTED */))
              ]),
              (_ctx.isAuthorized)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    "data-metadata": _ctx.microblog.metadata,
                    "data-url": _ctx.microblog.url,
                    class: "microblog-action",
                    title: "Zgłoś ten wpis"
                  }, [
                    _createVNode(_component_vue_icon, { name: "microblogReport" }),
                    _cache[25] || (_cache[25] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "d-none d-sm-inline" }, "Zgłoś", -1 /* HOISTED */))
                  ], 8 /* PROPS */, _hoisted_31))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.microblog.comments_count > Object.keys(_ctx.microblog.comments).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("span", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadComments(_ctx.microblog))),
                      class: "cursor-pointer"
                    }, [
                      _createVNode(_component_vue_icon, { name: "microblogCommentsFoldedUnfold" }),
                      _createTextVNode(" Zobacz " + _toDisplayString(_ctx.declination($options.totalComments, ['pozostały', 'pozostałe', 'pozostałe'])) + " " + _toDisplayString($options.totalComments) + " " + _toDisplayString(_ctx.declination($options.totalComments, ['komentarz', 'komentarze', 'komentarzy'])), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.microblog.comments, (comment) => {
                return (_openBlock(), _createBlock(_component_vue_comment, {
                  key: comment.id,
                  comment: comment,
                  onReply: $options.reply
                }, null, 8 /* PROPS */, ["comment", "onReply"]))
              }), 128 /* KEYED_FRAGMENT */)),
              (_ctx.isAuthorized)
                ? (_openBlock(), _createElementBlock("form", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives((_openBlock(), _createElementBlock("a", null, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_vue_avatar, {
                            photo: _ctx.user.photo,
                            name: _ctx.user.name,
                            initials: _ctx.user.initials,
                            class: "d-block"
                          }, null, 8 /* PROPS */, ["photo", "name", "initials"])
                        ])
                      ])), [
                        [_directive_profile, _ctx.user.id]
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_vue_comment_form, {
                          microblog: $data.commentDefault,
                          ref: "comment-form"
                        }, null, 8 /* PROPS */, ["microblog"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */)
          ])
        ])
      ]),
      _createVNode(_component_vue_gallery, {
        images: $options.imageUrls,
        index: $data.index,
        onClose: _cache[13] || (_cache[13] = ($event: any) => ($data.index = null))
      }, null, 8 /* PROPS */, ["images", "index"])
    ], 8 /* PROPS */, _hoisted_1)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}